<template>
  <div>
    <form @submit.prevent="onSubmit" class="row">
      <div class="col-xs-12 col-sm-6">
        <SfInput v-model="FirstName" name="FirstName" :label="$t('First Name')" required />
      </div>
      <div class="col-xs-12 col-sm-6">
        <SfInput v-model="LastName" name="LastName" :label="$t('Last Name')" required />
      </div>
      <div class="col-xs-12 col-sm-6">
        <SfInput v-model="Address1" name="Address1" :label="$t('Street Address')" required />
      </div>
      <div class="col-xs-12 col-sm-6">
        <SfInput v-model="Address2" name="Address2" :label="$t('Second Street Address')" />
      </div>
      <div class="col-xs-12 col-sm-6">
        <SfInput v-model="City" name="City" :label="$t('City')" required />
      </div>
      <div class="col-xs-12 col-sm-6">
        <SfInput v-model="ZipPostalCode" name="ZipPostalCode" :label="$t('Zip-code')" required />
      </div>
      <div class="col-xs-12 col-sm-6">
        <SfSelect
          class="sf-select--underlined"
          v-model="CountryId"
          name="CountryId"
          :label="$t('Country')"
          :placeholder="$t('Select option')"
          :required="true"
        >
          <SfSelectOption
            v-for="country in countries"
            :key="country.Id"
            :value="country.Id"
          >
            {{ country.Name }}
          </SfSelectOption>
        </SfSelect>
      </div>
      <div class="col-xs-12 col-sm-6">
        <SfSelect
          :key="CountryId"
          class="sf-select--underlined"
          v-model="StateProvinceId"
          name="StateProvinceId"
          :label="$t('State Province')"
          :placeholder="$t('Select option')"
          :disabled="!countryStateProvince.length"
          :required="!countryStateProvince.length"
        >
          <SfSelectOption
            v-for="state in countryStateProvince"
            :key="state.Id"
            :value="state.Id"
          >
            {{ state.Name }}
          </SfSelectOption>
        </SfSelect>
      </div>
      <div class="col-xs-12 col-sm-6">
        <SfInput v-model="PhoneNumber" type="tel" name="phone" :label="$t('Phone')" required />
      </div>
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12 col-sm-2">
            <SfButton type="submit" class="action-button">{{ $t('Save') }}</SfButton>
          </div>
          <div v-if="showCancelButton" class="col-xs-12 col-sm-2">
            <SfButton @click="$emit('cancelAddress')"
            class="action-button">{{ $t('Cancel') }}</SfButton>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { SfInput, SfButton, SfSelect } from '@storefront-ui/vue';
import { config } from '@/modules/core';

const defaultValues = {
  FirstName: '',
  LastName: '',
  Company: '',
  VatNumber: '',
  CountryId: '',
  StateProvinceId: '',
  City: '',
  Address1: '',
  Address2: '',
  ZipPostalCode: '',
  PhoneNumber: '',
  FaxNumber: '',
  Id: '',
};

export default {
  name: 'EditAddress',
  mixins: [config],
  components: {
    SfInput,
    SfButton,
    SfSelect,
  },
  props: {
    address: {
      type: Object,
      default: () => defaultValues,
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      ...this.address,
      countryStateProvince: [],
    };
  },
  watch: {
    CountryId() {
      this.countryStateProvince = this.filterStateProvince(this.CountryId);
    },
  },
  methods: {
    onSubmit() {
      const newAddress = Object.keys(defaultValues).reduce(
        (acc, cur) => ({
          ...acc,
          [cur]: this[cur],
        }),
        {},
      );
      this.$emit('submitAddress', newAddress);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

@include flexbox-mobile {
  .sf-button {
    --button-width: 100%;
    margin-bottom: var(--spacer-xs);
  }
}
</style>
